/*
 * SCSS → Tailwind token mapping (IntakeFormViewModeTablet.scss deleted):
 * .ifvmt-list -> flex flex-col gap-sp-2
 */
import { IntakeQuestionCard } from '../IntakeQuestionCard/IntakeQuestionCard'
import type { OptionItem } from '../IntakeQuestionCard/IntakeQuestionCard'

type QuestionItem = {
  IntakeFormQuestionId?: string | null
  id: string
  questionTypeValue: string
  rawType: string
  message: string
  isRequired: boolean
  options: OptionItem[]
}

type Props = {
  questionArray: QuestionItem[] | null | undefined
}

const IntakeFormViewModeTablet = ({ questionArray }: Props) => {
  if (!questionArray?.length) return null

  return (
    <div className='flex flex-col gap-sp-2'>
      {questionArray.map((question, i) => (
        <IntakeQuestionCard
          key={question.IntakeFormQuestionId ?? question.id}
          questionNumber={i + 1}
          questionType={question.questionTypeValue}
          rawType={question.rawType}
          questionMess={question.message}
          isRequired={question.isRequired}
          options={question.options}
        />
      ))}
    </div>
  )
}

export default IntakeFormViewModeTablet
